import React, { useState, useEffect } from 'react';
import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import ServicesSection from '@/components/ServicesSection';
import WhoWeHelpSection from '@/components/WhoWeHelpSection';
import PricingSection from '@/components/PricingSection';
import ServiceAreaSection from '@/components/ServiceAreaSection';
import FAQSection from '@/components/FAQSection';
import ContactSection from '@/components/ContactSection';
import Footer from '@/components/Footer';

const LandingPage = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* SEO Meta Tags are in public/index.html */}
      
      {/* LocalBusiness Schema JSON-LD */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Flex Plastering",
          "description": "Professional plastering and rendering services in Northampton and surrounding areas.",
          "url": "https://flexplastering.co.uk",
          "telephone": "07766 111127",
          "email": "info@flexplastering.co.uk",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Northampton",
            "addressRegion": "Northamptonshire",
            "addressCountry": "GB"
          },
          "areaServed": {
            "@type": "GeoCircle",
            "geoMidpoint": {
              "@type": "GeoCoordinates",
              "latitude": 52.2405,
              "longitude": -0.9027
            },
            "geoRadius": "30000"
          },
          "serviceArea": {
            "@type": "AdministrativeArea",
            "name": "Northamptonshire"
          },
          "priceRange": "$$",
          "openingHours": "Mo-Fr 08:00-18:00, Sa 09:00-14:00",
          "sameAs": [],
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Plastering Services",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Wall & Ceiling Skimming"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Plasterboarding & Dry Lining"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Rendering"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Patch Repairs"
                }
              }
            ]
          }
        })
      }} />

      <Header isScrolled={isScrolled} />
      
      <main>
        <HeroSection />
        <ServicesSection />
        <WhoWeHelpSection />
        <PricingSection />
        <ServiceAreaSection />
        <FAQSection />
        <ContactSection />
      </main>

      <Footer />
    </div>
  );
};

export default LandingPage;
